import { render } from "./InstallWizardPhysicalInstall.vue?vue&type=template&id=53f6661c"
import script from "./InstallWizardPhysicalInstall.vue?vue&type=script&lang=js"
export * from "./InstallWizardPhysicalInstall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__